// extracted by mini-css-extract-plugin
export default {"generateButton":"style_generateButton__nc00R"};